/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Land_DocumentsInputs */

const vi_grower_land_documents = /** @type {(inputs: Grower_Land_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giấy tờ vùng trồng`)
};

/**

* @param {Grower_Land_DocumentsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_land_documents = /** @type {((inputs?: Grower_Land_DocumentsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Land_DocumentsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_land_documents(inputs)
});